import { CARGO_TYPE } from '@types';

export const isCargoTypeCartonOrSatchel = (type: CARGO_TYPE | null) => {
	return type === CARGO_TYPE.PARCELS;
}